var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypeBold({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5994 14.6253C11.9686 14.6253 13.4379 13.4024 13.4379 11.4494C13.4379 9.9802 12.3309 8.88107 10.8234 8.7652V8.70332C11.4007 8.6164 11.928 8.32601 12.31 7.88456C12.6921 7.4431 12.9037 6.87963 12.9069 6.29582C12.9069 4.59707 11.5996 3.52832 9.51615 3.52832H4.68652V14.6253H9.5994ZM7.00965 5.25857H8.91765C10.001 5.25857 10.6243 5.76595 10.6243 6.65807C10.6243 7.59632 9.91665 8.14307 8.67802 8.14307H7.00965V5.25745V5.25857ZM7.00965 12.8951V9.67307H8.9559C10.325 9.67307 11.0709 10.2266 11.0709 11.2649C11.0709 12.3258 10.3475 12.8951 9.0099 12.8951H7.00852H7.00965Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeBold);
export default __webpack_public_path__ + "static/media/type-bold.1f89c13eb8e11114dc0eea16cfdbf4f5.svg";
export { ForwardRef as ReactComponent };